import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { AppComponent } from './app.component';
import { LayoutModule } from './layout/layout.module';
import { CatalogosProcesModule } from './modulos/catalogos-proces/catalogos-proces.module';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { JwtInterceptor } from './helpers/jwt.interceptor';
import { AdminModule } from './modulos/admin/admin.module';
import { SpinnerModule } from './shared/components/spinner/spinner.module';
import { SpinnerInterceptor } from './shared/interceptors/spinner.interceptor';
import { CatalogosAdminModule } from './modulos/catalogos-admin/catalogos-admin.module';
import { FormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { appReducers, metaReducers} from "./app.reducer"
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from 'src/environments/environment';
import { EffectsModule } from '@ngrx/effects';
import { UsuarioEffects } from './redux/usuario/usuario.effects';
import { GlobalEffects } from './redux/global/global.effects';
import { NgxSpinnerModule } from 'ngx-spinner';



@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    LayoutModule,
    SpinnerModule,
    CatalogosProcesModule,
    CatalogosAdminModule,
    HttpClientModule,
    FormsModule,
    AdminModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true
    }),
    StoreModule.forRoot(appReducers, {metaReducers}),
    StoreDevtoolsModule.instrument({
      maxAge:25,
      logOnly: environment.production
    }),
    EffectsModule.forRoot([UsuarioEffects, GlobalEffects ]),
    AppRoutingModule,
    NgxSpinnerModule
  ],
  providers: [
   {provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true},
   {provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true},
   {provide: LocationStrategy, useClass: HashLocationStrategy}
  ],
  
  bootstrap: [AppComponent]
})
export class AppModule { }
